import { configurePdf417Decoder } from '@dutchie/capacitor-hardware';
// Emitted as an app asset by Vite, so the binary ships from our origin with the build. Without
// this, zxing-wasm fetches it from jsDelivr, which a locked-down dispensary network may block.
import wasmUrl from 'zxing-wasm/reader/zxing_reader.wasm?url';

/**
 * Hands the decoder this app's own copy of the binary.
 *
 * The accepted/refused result is deliberately ignored: a refusal is already logged as an error by
 * the decoder, and the only caller is a mount effect with nowhere to put a boolean. What matters is
 * that a refusal leaves the decoder unconfigured, so the next decode fails closed rather than
 * reaching a CDN a dispensary network may block.
 */
export const preparePdf417Decoder = (): void => {
  configurePdf417Decoder(wasmUrl);
};
